import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { API, useAuth } from "@/App";
import axios from "axios";
import { Loader2 } from "lucide-react";

const IntegrationCallback = () => {
  const { provider } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const error = searchParams.get("error");
      const errorDescription = searchParams.get("error_description");

      if (error) {
        navigate(`/integrations?error=${encodeURIComponent(errorDescription || error)}`, { replace: true });
        return;
      }

      if (!code || !state) {
        navigate("/integrations?error=Missing authorization code", { replace: true });
        return;
      }

      try {
        const endpoint = {
          google: "/integrations/email/google/callback",
          microsoft: "/integrations/email/microsoft/callback",
          docusign: "/integrations/docusign/callback",
          stripe: "/integrations/stripe/callback"
        }[provider];

        if (!endpoint) {
          navigate("/integrations?error=Unknown provider", { replace: true });
          return;
        }

        await axios.post(
          `${API}${endpoint}`,
          null,
          {
            params: { code, state },
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );

        navigate(`/integrations?success=true&provider=${provider}`, { replace: true });
      } catch (err) {
        const errorMsg = err.response?.data?.detail || "Authorization failed";
        navigate(`/integrations?error=${encodeURIComponent(errorMsg)}`, { replace: true });
      }
    };

    processCallback();
  }, [provider, searchParams, navigate, token]);

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-forest mx-auto mb-4" />
        <p className="text-lg font-medium text-forest">Completing authorization...</p>
        <p className="text-sm text-muted-foreground mt-2">Please wait while we connect your {provider} account.</p>
      </div>
    </div>
  );
};

export default IntegrationCallback;
